import moment from 'moment'

export const getValueFromObject = (object: object, id: number | string) =>
  Object.values(object).find((item) => item.id === id)

export const getValueFromArray = (array: any[], id: number | string) => array.find((item) => item.id === id)

export const isNextDate = (date1: string, date2: string): boolean =>
  moment(date1).format('MM-DD-YYYY') !== moment(date2).format('MM-DD-YYYY')

/**
 * Получение списка рандомных чисел без повторений
 * @param n - правая граница диопазона. [0, n]
 * @param count - количество нужных чисел
 */
export const getRandomNumbers = (n: number, count: number): number[] => {
  const numbers: number[] = []

  for (let i = 0; i < count; i++) {
    let randomNumber

    do {
      randomNumber = Math.floor(Math.random() * (n + 1))
    } while (numbers.includes(randomNumber))

    numbers.push(randomNumber)
  }

  return numbers
}

export const displayCount = (count: number) => count > 10 ? '10+' : count